import * as XLSX from 'xlsx';

/**
 * Exporta inventario (lotes) e historial de ingresos/movimientos a Excel.
 */
export function exportStockExcel({ zones = {}, movements = [] }) {
  const lotsRows = [];
  Object.entries(zones).forEach(([zoneName, lots]) => {
    (lots || []).forEach((lot) => {
      lotsRows.push({
        Zona: zoneName,
        Repisa: lot.shelfLetter || '',
        Estante: lot.shelfNumber || '',
        'Cód. producto': lot.product?.code || '',
        Producto: lot.product?.name || '',
        Cantidad: lot.quantity ?? 0,
        Vencimiento: lot.expirationDate
          ? new Date(lot.expirationDate).toLocaleDateString('es-UY')
          : '',
        'Último control': lot.lastCheckUser?.name || '',
        'Fecha control': lot.lastCheckAt
          ? new Date(lot.lastCheckAt).toLocaleString('es-UY')
          : '',
        'ID lote': lot.id,
      });
    });
  });

  const movementRows = (movements || []).map((m) => ({
    Fecha: m.createdAt ? new Date(m.createdAt).toLocaleString('es-UY') : '',
    Tipo: m.movementType,
    Producto: m.product?.name || '',
    Código: m.product?.code || '',
    Zona: m.lot?.zone || '',
    Repisa: m.lot?.shelfLetter || '',
    Estante: m.lot?.shelfNumber || '',
    'Cant. anterior': m.previousQuantity ?? '',
    Cambio: m.quantity,
    'Cant. nueva': m.newQuantity ?? '',
    Usuario: m.user?.name || '',
    Motivo: m.notes || '',
    Servicio: m.vehicleServiceId ? `#${m.vehicleServiceId}` : '',
  }));

  const ingresos = movementRows.filter((r) => r.Tipo === 'in' || r.Cambio > 0);

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    wb,
    XLSX.utils.json_to_sheet(lotsRows.length ? lotsRows : [{ Info: 'Sin lotes' }]),
    'Stock por ubicación',
  );
  XLSX.utils.book_append_sheet(
    wb,
    XLSX.utils.json_to_sheet(ingresos.length ? ingresos : [{ Info: 'Sin ingresos' }]),
    'Ingresos',
  );
  XLSX.utils.book_append_sheet(
    wb,
    XLSX.utils.json_to_sheet(movementRows.length ? movementRows : [{ Info: 'Sin movimientos' }]),
    'Todos los movimientos',
  );

  const date = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `inventario_${date}.xlsx`);
}
